import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ childrenWithEllipsis }: { childrenWithEllipsis: boolean }) =>
    childrenWithEllipsis &&
    css`
      width: 100%;
    `}
`;
